var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import mixins from 'vue-typed-mixins';
import { ActivityManagerTyped as ActivityManager } from 'mixins/ActivityManager';
import TypingActivityHelper from 'mixins/TypingActivityHelper';
import ErrorLogger from 'mixins/ErrorLogger';
import ActivityStage from 'components/activity/ActivityStage.vue';
import TextEditor from 'components/inputs/TextEditor';
import HtmlRenderer from '../components/activity/HtmlRenderer.vue';
import KeyboardAdaptationWrapper from '../components/activity/KeyboardAdaptationWrapper.vue';
const INCORRECT_ATTEMPT = 'INCORRECT_ATTEMPT';
const EMPTY_VOICE_ATTEMPT = 'EMPTY_VOICE_ATTEMPT';
export default mixins(ActivityManager(), TypingActivityHelper, ErrorLogger).extend({
    name: 'ConstructResponse',
    components: {
        ActivityStage,
        HtmlRenderer,
        KeyboardAdaptationWrapper,
        TextEditor
    },
    data() {
        return {
            answer: '',
            maxLength: 3000,
            sounds: new Map(),
            isComplete: false
        };
    },
    mounted() {
        this.maxLength = this.getActivityState().settings.maxCharacterCount;
    },
    beforeDestroy() {
        this.hideKeyboard();
    },
    methods: {
        handleOnActivitySubmit() {
            var _a;
            if (this.isComplete) {
                return;
            }
            const { settings } = this.getActivityState();
            const characterCount = (_a = this.$refs
                .textEditor.editor) === null || _a === void 0 ? void 0 : _a.storage.characterCount.characters();
            this.incrementNumberOfAttempts();
            if (characterCount === 0) {
                this.playAudio(EMPTY_VOICE_ATTEMPT);
                return;
            }
            if (characterCount < settings.minCharacterCount) {
                this.playAudio(INCORRECT_ATTEMPT);
                return;
            }
            this.isComplete = true;
            this.setResponseData([{ text: this.answer }]);
            this.processEndOfActivity();
        },
        handleCorrectKey({ character }) {
            if (character === 'tab')
                return;
            this.sndType();
        },
        getActivityState() {
            const { rounds, emptyAttempt, incorrectAttempt, settings } = this.activityData;
            return {
                instructions: Object.assign(Object.assign({}, rounds[0].instructions), { text: rounds[0].instructions.audio.description }),
                emptyAttemptVoice: emptyAttempt.audio,
                incorrectAttemptVoice: incorrectAttempt.audio,
                settings
            };
        },
        loadActivity() {
            return __awaiter(this, void 0, void 0, function* () {
                const roundSetup = this.getActivityState();
                this.createRounds(roundSetup);
                const audiosMap = {
                    [INCORRECT_ATTEMPT]: roundSetup.incorrectAttemptVoice.src,
                    [EMPTY_VOICE_ATTEMPT]: roundSetup.emptyAttemptVoice.src
                };
                const audioDescriptionsMap = {
                    [INCORRECT_ATTEMPT]: roundSetup.incorrectAttemptVoice.description,
                    [EMPTY_VOICE_ATTEMPT]: roundSetup.emptyAttemptVoice.description
                };
                this.sfx = yield this.loadAAAudios(audiosMap);
                this.sfxDescriptions = audioDescriptionsMap;
            });
        },
        startActivity() {
            this.$nextTick(this.setActivityContainerHeight);
            this.setRound();
        },
        setRound() {
            this.setupNewRound();
            this.enableKeyboard();
            this.setFreeTextTyping(true);
            this.errorLoggerStart();
        },
        getKeyboardConfig() {
            const { keyboardType, roofs, showNumbers, characters } = this.activityData.keyboard;
            return {
                keyboardType,
                hideNumberRow: !showNumbers,
                characters,
                roofs,
                keyCodesToNotHandleNatively: ['all'],
                keyCodesToHandleNatively: [9, 13]
            };
        }
    }
});
